import { Box, Button, Title } from "@mantine/core";
import React, { FC, ReactElement, useState } from "react";

type ButtonsSelectProps = {
  value: any;
  numberOfColumns?: number;
  align?: "left" | "center" | "right";
  data:
    | {
        value: any;
        label: string | ReactElement;
      }[]
    | {
        group?: string;
        items: {
          value: any;
          label: string | ReactElement;
        }[];
      }[];
  onChange: (value: any) => void;
};

export const ButtonsSelect: FC<ButtonsSelectProps> = ({
  data,
  numberOfColumns = 2,
  align = "center",
  value,
  onChange,
}) => {
  const [val, setVal] = useState(value);
  const isGrouped = data.length > 0 && "items" in data[0];

  if (!isGrouped) {
    return (
      <Box
        style={theme => ({
          display: "grid",
          gridAutoRows:
            numberOfColumns === 1 ? "minmax(80px, auto)" : undefined,
          gridRowGap: theme.spacing.sm,
          gridTemplateColumns:
            numberOfColumns === 3
              ? "1fr 1fr 1fr"
              : numberOfColumns === 1
                ? "1fr"
                : "1fr 1fr",
          minHeight: "30%",
          minWidth: "30%",
          alignContent: "center",
          justifyContent: "center",
        })}
      >
        {data.map(item => (
          <Button
            key={item.value}
            variant="light"
            onClick={() => {
              onChange(item.value);
              setVal(item.value);
            }}
            data-testid={`button-select-${item.value}`}
            value={val}
            color={item.value === value ? "blue" : "gray"}
            p="xs"
            m="5px"
            style={() => ({
              minHeight: "100%",
              display: "flex",
              border: item.value === value ? "2px solid #228be6" : "0",
              justifyContent:
                align === "center"
                  ? "center"
                  : align === "left"
                    ? "flex-start"
                    : "flex-end",
              textAlign: align,
            })}
          >
            {item.label}
          </Button>
        ))}
      </Box>
    );
  }

  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {data.map((groupData, groupIndex) => (
        <Box key={groupIndex}>
          {groupData.group && (
            <Title order={6} style={{ marginBottom: "10px", fontWeight: 600 }}>
              {groupData.group}
            </Title>
          )}
          <Box
            style={theme => ({
              display: "grid",
              gridRowGap: theme.spacing.sm,
              gridColumnGap: theme.spacing.sm,
              gridTemplateColumns:
                numberOfColumns === 3
                  ? "1fr 1fr 1fr"
                  : numberOfColumns === 1
                    ? "1fr"
                    : "1fr 1fr",
              alignContent: "center",
              justifyContent: "center",
              marginBottom: theme.spacing.md,
            })}
          >
            {groupData.items?.map(item => (
              <Button
                key={item.value}
                variant="light"
                onClick={() => {
                  onChange(item.value);
                  setVal(item.value);
                }}
                data-testid={`button-select-${item.value}`}
                value={val}
                color={item.value === value ? "blue" : "gray"}
                p="xs"
                m="5px"
                style={() => ({
                  height: "auto",
                  minHeight: "44px",
                  display: "flex",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  border: item.value === value ? "2px solid #228be6" : "0",
                  justifyContent:
                    align === "center"
                      ? "center"
                      : align === "left"
                        ? "flex-start"
                        : "flex-end",
                  textAlign: align,
                })}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
